<template>
  <div class="upgrade-paln">
    <witeBlock class="mt-6"/>
    <div v-if="!decline">
      <v-container>
        <ytplayer v-if="!videoEnded" class="mb-2" videoId='AwjL_0IeTEk' :points="points" @ended="videoEnded = true"></ytplayer>
        <div v-else class="arrow bounce-arrow"><iconDownArrow /></div>
      </v-container>

      <div v-if="!videoEnded" class="attention mb-6">
        <span>
          {{ $t('onboardingSpecial.progress.doThisFirst') }}:
        </span>
        {{ $t('onboardingSpecial.progress.doThisFirstText') }}
      </div>
    </div>

    <div v-else class="white-bg mt-6">
      <v-container>
        <div class="steps d-flex justify-center mt-10 mb-10">
          <div class="step step-1 d-flex flex-column align-center">
            <iconCheck class="icon-check mb-3"/>
            <div class="mb-1">{{ $t('onboardingSpecial.progress.step') }} 1</div>
            <div>{{ $t('onboardingSpecial.progress.createAccount') }}</div>
          </div>

          <div class="divider active"></div>

          <div class="step step-2 d-flex flex-column align-center">
            <div class="circle active mb-3"></div>
            <div class="mb-1">{{ $t('onboardingSpecial.progress.step') }} 2</div>
            <div>{{ $t('onboardingSpecial.progress.customizeOrder') }}</div>
          </div>

          <div class="divider"></div>

          <div class="step step-3 d-flex flex-column align-center">
            <div class="circle mb-3"></div>
            <div class="mb-1">{{ $t('onboardingSpecial.progress.step') }} 3</div>
            <div>{{ $t('onboardingSpecial.progress.orderComplete') }}</div>
          </div>
        </div>

        <div class="status-wrapper d-flex align-center justify-center flex-column mb-12">
          <div class="status-text">
            {{ $t('onboardingSpecial.progress.specialStatus') }}:
          </div>
          <div class="d-flex align-center mt-2 mb-0 mt-xs-2 mb-xs-2">
            <iconCheckActivated class="check-activated ml-2 mr-2"/>
            <div class="status">
              <div>
                {{ $t('onboardingSpecial.progress.activated') }}
              </div>
            </div>
          </div>
          <div class="additional mt-1">3 x {{ $t('onboardingSpecial.progress.paymentsOf') }}
            <b>
              $49.99
            </b>
          </div>
        </div>
      </v-container>
    </div>

    <div class="white-bg" v-if="showContentAfterVideo">
      <v-container>
        <upgradePlanInformation @updateDecline="decline = $event" :decline="decline" />
      </v-container>
    </div>
  </div>
</template>

<script>
import iconDownArrow from '@/static/custom-img/down-arrow.svg';
import iconCheck from '@/static/custom-img/iconCheck.svg';
import iconCheckActivated from '@/static/custom-img/iconCheckActivated.svg';
import witeBlock from '@/components/onboarding/upgradePlan/waitBlock';
import upgradePlanInformation from '@/components/onboarding/upgradePlan/information';
import ytplayer from '@/components/base/ytplayer';

export default {
  components: {
    iconDownArrow,
    witeBlock,
    upgradePlanInformation,
    iconCheckActivated,
    iconCheck,
    ytplayer,
  },

  data () {
    return {
      videoEnded: false,
      decline: false,
      showContentAfterVideo: false,
    };
  },

  computed: {
    points () {
      return [
        {
          time: process.env.VUE_APP_ENV === 'dev' ? 10 : 505,
          cb: () => {
            if (!this.showContentAfterVideo) {
              this.showContentAfterVideo = true;
            }
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.attention {
  margin: auto;
  max-width: 730px;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 14px;
    line-height: 17px;
  }

  span {
    color: #FA507B;
    text-transform: uppercase;
  }
}

.step {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 12px;
    line-height: 17px;
  }
}

.icon-check {
  width: 32px;
  height: 32px;
}

.circle {
  width: 32px;
  height: 32px;
  border: 1px solid #D9D9D9;
  border-radius: 50%;

  &.active {
    border-color: #59D45B;
  }
}

.divider {
  width: 100px;
  height: 1px;
  border-radius: 2px;
  margin-top: 12px;
  background: #D9D9D9;

  &.active {
    background: #59D45B;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    width: 40px;
  }
}

.step-3  {
  color: #D9D9D9;
}

.status-wrapper {
  font-weight: bold;
  font-size: 32px;
  line-height: 39px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    flex-direction: column;
    font-size: 21px;
    line-height: 27px;
  }

  .status {
    font-weight: bold;
    font-size: 42px;
    line-height: 51px;
    text-align: center;
    letter-spacing: -0.175px;
    color: #59D45B;

    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 32px;
      line-height: 39px;
    }
  }
}

.additional {
  margin-bottom: -30px;
  color: #44445E;
  font-weight: 500;
  font-size: 42px;
  line-height: 42px;
  text-align: center;
  letter-spacing: -0.175px;
  text-transform: uppercase;
  background-image: url('~@/static/custom-img/titleRectangle.png');
  background-size: 100%;
  background-position: 50% 50%;
  padding: 15px 35px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 22px;
    line-height: 34px;
    padding: 6px 12px;
  }
}

.white-bg {
  background-color: white;
}

.arrow {
  svg {
    width: 280px;
    height: 210px;
  }
}
</style>
